export enum SessionEvents {
  EXCHANGE_TENANT_TOKEN = 'exchangeTenantToken',
  REFRESH_TOKEN = 'refreshToken',
  LOGGEDIN_FINISHED = 'internalLoggedinFinished',
  LOGIN_CHANGE = 'loginChange',
  USER_LOGGED_IN = 'userLoggedIn',
  USER_LOGGED_OUT = 'userLoggedOut',
  USER_CHANGE = 'userChange',
  TENANT_CHANGE = 'tenantChange',
  FORCE_LOGIN = 'forceLogin',
  FORCED_LOGOUT = 'forcedLogout'
}

export default class SessionObserver {
  private static _listeners: Record<string, Function[]> = {};

  public static subscribe = (event: SessionEvents, cb: Function): void => {
    if (!this._listeners?.[`${event}`]) this._listeners[`${event}`] = [];
    !this._listeners?.[`${event}`]?.includes(cb) &&
      this._listeners?.[`${event}`]?.push(cb);
  };

  public static unsubscribe = (event: SessionEvents, cb: Function): void => {
    this._listeners[`${event}`] = this._listeners?.[`${event}`]?.filter(
      (c) => c != cb
    );
  };

  public static notify = async (
    event: SessionEvents,
    payload: unknown
  ): Promise<void> => {
    const notifyEvent = this._listeners?.[`${event}`];
    if (!notifyEvent) return;
    for (const callback of notifyEvent) {
      await callback(payload);
    }
  };
}
